<div class="profile-container" data-testid="profile-container">
  <!-- Personal Info Card -->
  <div class="modern-profile-card" data-testid="profile-card-personal">
    <div class="card-header">
      <i class="dx-icon dx-icon-user" style="color: #3b84c2"></i>
      <h4>Personal Info</h4>
    </div>
    <div class="card-body">
      <div class="profile-layout">
        <!-- Picture Section -->
        <div class="picture-section">
          <app-user-picture></app-user-picture>
        </div>

        <!-- Form Section -->
        <div class="form-section">
          <form (submit)="onProfileSubmit($event)">
            <dx-form
              id="form"
              [formData]="profile_data"
              [readOnly]="false"
              [showColonAfterLabel]="false"
              [showValidationSummary]="false"
              validationGroup="customerData"
              labelMode="floating"
              [elementAttr]="{ 'data-testid': 'profile-form-main' }"
            >
              <dxi-item itemType="group" [colCount]="2" [colCountByScreen]="{ xs: 1, sm: 2 }">
                <dxi-item
                  dataField="phone"
                  [editorOptions]="{
                    mask: '(000) 000-0000',
                    useMaskedValue: false,
                    maskInvalidMessage: 'The phone must have a correct USA phone format'
                  }"
                ></dxi-item>
                <dxi-item dataField="email" [editorOptions]="{ disabled: true }">
                  <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                  <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group">
                <div class="password-row">
                  <p>Security & Password</p>
                  <a class="link-reset" (click)="openUpdatePasswordPopup()">
                    Change Password
                    <i class="dx-icon dx-icon-chevronright" style="font-size: 0.8rem"></i>
                  </a>
                </div>
              </dxi-item>

              <dxi-item itemType="group" class="action-row">
                <dx-button
                  text="Update"
                  type="success"
                  [useSubmitBehavior]="true"
                  height="44px"
                  [width]="140"
                  class="mt-4"
                  [elementAttr]="{ 'data-testid': 'profile-btn-update' }"
                ></dx-button>
              </dxi-item>
            </dx-form>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Email Subscriptions Card -->
  <div *ngIf="!hydraEnabled" class="modern-profile-card" data-testid="profile-card-subscriptions">
    <div class="card-header">
      <i class="dx-icon dx-icon-email" style="color: #3b84c2"></i>
      <h4>Email Subscriptions</h4>
    </div>
    <div class="card-body">
      <div *ngIf="!loading">
        <app-subscribe-emails [userId]="profile?.data?.id"></app-subscribe-emails>
      </div>
    </div>
  </div>
</div>

<dx-popup
  [showTitle]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [width]="'min(400px, 95vw)'"
  [height]="'auto'"
  title="Update Your Password"
  [showCloseButton]="true"
  [(visible)]="isPasswordPopupOpen"
  (hiding)="closingPasswordPopup()"
  [elementAttr]="{ 'data-testid': 'profile-popup-password' }"
>
  <div class="p-4">
    <app-password-update></app-password-update>
  </div>
</dx-popup>
